import { useSubmitDownloadRequest } from "../api/queries/certificate-reporting/new-certificates/use-submit-download";

export function useDownload(identifiers: string[], fullColor: boolean) {
    
    const mutation = useSubmitDownloadRequest(identifiers, fullColor);

    return {mutation, mutate: () => mutation.mutate({identifiers, fullColor})};
}
